import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '../../theme/style';


const baseStyles = {
  curveTable: {
    fontWeight: 900,
    color: 'rgb(93,172,8)',
    fontSize: '1.2rem',
  },
  degrees: {
    background: '#fff',
    color: colors.gunmetal,
    border: '1px solid rgb(107,126,134)',
    borderRadius: '5px',
    padding: '0.5rem',
    width: '2.5vw',
  },
  degreesP: {
    color: colors.gunmetal,
    marginLeft: '1rem',
    fontSize: '1.2rem',
  },
  flex: {
    display: 'flex',
    // width: '35rem',
    justifyContent: 'flex-start',
    alignItems: 'center',
  }
};


const ThoracicDegreeTables = (props) => {
  const tableStyle = Object.assign({}, baseStyles.curveTable, props.tableStyle);
  return(
    <section style={props.style}>
      <p style={tableStyle}>{props.curveTable}</p>
      <p>{props.image_taken}</p>
      <div style={baseStyles.flex}>
        <div style={baseStyles.degrees}>{`${props.leftThoracic}°`}</div>
        <p style={baseStyles.degreesP}>Left Thoracic with T8 Apex</p>
      </div>
      <div style={baseStyles.flex}>
        <div style={baseStyles.degrees}>{`${props.rightThoracic}°`}</div>
        <p style={baseStyles.degreesP}>Right Thoracic Curve</p>
      </div>
      <div style={baseStyles.flex}>
        <div style={baseStyles.degrees}>{`${props.leftLumbar}°`}</div>
        <p style={baseStyles.degreesP}>Left Lumbar Curve</p>
      </div>
    </section>
  )
};

ThoracicDegreeTables.propTypes = {
  leftThoracic: PropTypes.number,
  rightThoracic: PropTypes.number,
  leftLumbar: PropTypes.number,
  tableStyle: PropTypes.object,
};

ThoracicDegreeTables.defaultProps = {
  leftThoracic: null,
  rightThoracic: null,
  leftLumbar: null,
  tableStyle: {},
};

export default ThoracicDegreeTables;
